import { useEffect, useRef } from "react";
import gsap from "gsap";

export const ProgressBar = ({ step, total = 3 }) => {
  const indicatorRef = useRef(null);
  const target = Math.min(100, Math.round((step / total) * 100));

  useEffect(() => {
    if (!indicatorRef.current) return;
    gsap.to(indicatorRef.current, {
      width: `${target}%`,
      duration: 0.9,
      ease: "power3.out",
    });
  }, [target]);

  return (
    <div
      data-testid="progress-bar"
      className="fixed top-0 left-0 w-full h-[3px] bg-zinc-200 dark:bg-zinc-900/80 z-50"
    >
      <div
        ref={indicatorRef}
        className="h-full bg-zinc-900 dark:bg-zinc-50 shadow-[0_0_20px_rgba(0,0,0,0.15)] dark:shadow-[0_0_20px_rgba(255,255,255,0.4)]"
        style={{ width: "0%" }}
      />
    </div>
  );
};
